import apiClient from "@/app/api/client";
import type {
	FormSchema,
	LeadForm,
	LeadFormAssignment,
	LeadFormAssignmentKind,
	LeadFormDetail,
	LeadFormVersion,
} from "../types";

interface Envelope<T> {
	success: true;
	data: T;
}

export interface LeadFormInput {
	name: string;
	description?: string | null;
}

export const leadFormsService = {
	/**
	 * ⚠️ `GET /lead-forms` SAHIFALANMAGAN — javob `createSuccessSchema`
	 * bilan qurilgan tekis massiv, so'rovda `page`/`limit` yo'q, faqat
	 * `isActive` (`lead-forms.routes.ts`). Shu sabab `usePaginatedQuery`
	 * emas, oddiy `useQuery` ishlatiladi (`schedules` naqshi).
	 */
	async list(isActive: boolean): Promise<LeadForm[]> {
		const response = await apiClient.get<Envelope<LeadForm[]>>("/lead-forms", {
			params: { isActive },
		});
		return response.data.data;
	},

	async get(id: string): Promise<LeadFormDetail> {
		const response = await apiClient.get<Envelope<LeadFormDetail>>(`/lead-forms/${id}`);
		return response.data.data;
	},

	async create(input: LeadFormInput): Promise<LeadForm> {
		const response = await apiClient.post<Envelope<LeadForm>>("/lead-forms", input);
		return response.data.data;
	},

	async update(id: string, input: Partial<LeadFormInput>): Promise<LeadForm> {
		const response = await apiClient.patch<Envelope<LeadForm>>(`/lead-forms/${id}`, input);
		return response.data.data;
	},

	/**
	 * ⚠️ Forma o'chirilmaydi — arxivlanadi (spec §7.2). Versiyalari
	 * joyida qoladi, chunki eski lidlar ularga ishora qiladi.
	 */
	async archive(id: string): Promise<LeadForm> {
		const response = await apiClient.post<Envelope<LeadForm>>(`/lead-forms/${id}/archive`);
		return response.data.data;
	},

	async getVersion(id: string, version: number): Promise<LeadFormVersion> {
		const response = await apiClient.get<Envelope<LeadFormVersion>>(
			`/lead-forms/${id}/versions/${version}`
		);
		return response.data.data;
	},

	/**
	 * Nashr = YANGI versiya. Mavjud versiyani tahrirlash marshruti YO'Q
	 * va bo'lmaydi ham — sxema nashrdan keyin o'zgarmas.
	 */
	async publish(id: string, schema: FormSchema): Promise<LeadFormVersion> {
		const response = await apiClient.post<Envelope<LeadFormVersion>>(`/lead-forms/${id}/versions`, {
			schema,
		});
		return response.data.data;
	},

	async listAssignments(id: string): Promise<LeadFormAssignment[]> {
		const response = await apiClient.get<Envelope<LeadFormAssignment[]>>(
			`/lead-forms/${id}/assignments`
		);
		return response.data.data;
	},

	/** ⚠️ `PUT` — to'liq almashtirish, qo'shish emas. */
	async replaceAssignments(
		id: string,
		assignments: { kind: LeadFormAssignmentKind; targetId: string }[]
	): Promise<LeadFormAssignment[]> {
		const response = await apiClient.put<Envelope<LeadFormAssignment[]>>(
			`/lead-forms/${id}/assignments`,
			{ assignments }
		);
		return response.data.data;
	},
};
